import { Controller } from "@hotwired/stimulus";
import debounce from "debounce";

export default class extends Controller {
  initialize() {
    this.submit = debounce(this.submit.bind(this), 500);
  }

  submit() {
    this.element.requestSubmit();
  }

  setActiveTabParam(e) {
    const tab = e.currentTarget;
    const recordType = tab.dataset.id;
    const url = new URL(window.location.href);
    url.searchParams.set("active_tab", recordType);
    window.history.replaceState(null, null, url);
  }

  clear() {
    const inputs = this.element.querySelectorAll("input[type='text'], input[type='search'], input[type='date']");
    for (let i = 0; i < inputs.length; i += 1) {
      inputs[i].value = "";
    }

    // Clear all Tom Select inputs without triggering change event
    const tsInputs = this.element.getElementsByClassName("tomselected");
    for (let i = 0; i < tsInputs.length; i += 1) {
      if (tsInputs[i].hasOwnProperty("tomselect")) {
        tsInputs[i].tomselect.clear(true);
      }
    }

    // Focus the first input so the user can start searching immediately
    inputs[0]?.focus();
  }
}
